// "Become a partner" applications — platform staff review/approve prospective
// lending partners. Approval provisions the partner out-of-band (credit.partners +
// partner tenant + partner_owner invite) in auth-service. See the partner
// onboarding flow.
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);

export interface PartnerApplication {
  id: string;
  companyName: string;
  contactName: string;
  email: string;
  phone?: string | null;
  country?: string | null;
  taxId?: string | null;
  fundingIntent?: string | null;
  // Partner Network track: referral | solution | implementation | financial
  requestedPartnerType?: string | null;
  website?: string | null;
  industry?: string | null;
  geographicCoverage?: string[] | null;
  estimatedNetworkSize?: string | null;
  notes?: string | null;
  status: string; // submitted | approved | rejected
  rejectionReason?: string | null;
  reviewedBy?: string | null;
  reviewedAt?: string | null;
  partnerId?: string | null;
  tenantId?: string | null;
  createdAt: string;
  updatedAt: string;
}

// The review queue. Default to the pending (submitted) applications.
export const getApplications = (status = 'submitted') =>
  axios
    .get<PartnerApplication[]>(`${API_V1}/partner-applications/admin`, { params: { status } })
    .then((r) => r.data ?? []);

// Approve → provisions the partner + invites the first owner by email.
export const approveApplication = (id: string) =>
  axios.post(`${API_V1}/partner-applications/admin/${id}/approve`).then((r) => r.data);

export const rejectApplication = (id: string, reason?: string) =>
  axios.post(`${API_V1}/partner-applications/admin/${id}/reject`, { reason }).then((r) => r.data);
